<template>
  <div id="breakpoints-page" class="page-wrapper">
    <h1>Breakpoints</h1>

    <!-- Breakpoints Section -->
    <section class="token-section">
      <h2>Screen Breakpoints</h2>
      <div class="breakpoint-list">
        <div v-for="(breakpoint, name) in breakpoints" :key="name" class="token-item">
          <code class="token-name">{{ name }}</code>
          <div class="token-value">{{ breakpoint }}px</div>
        </div>
      </div>
    </section>

    <!-- Screen Margins Section -->
    <section class="token-section">
      <h2>Screen Margins</h2>
      <div class="margin-preview">
        <div v-for="(margin, name) in screenMargins" :key="name" class="margin-item">
          <div class="margin-box" :style="{ padding: `0 ${margin}px` }">
            <div class="content"></div>
          </div>
          <code class="token-name">{{ name }}</code>
          <div class="token-value">{{ margin }}px</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data () {
    return {
      breakpoints: {
        '$breakpoint-sm': 360,
        '$breakpoint-2sm': 480,
        '$breakpoint-3sm': 600,
        '$breakpoint-md': 768,
        '$breakpoint-2md': 900,
        '$breakpoint-3md': 1024,
        '$breakpoint-lg': 1280,
        '$breakpoint-2lg': 1440,
        '$breakpoint-3lg': 1600
      },
      screenMargins: {
        '$screen-margin-sm': 20,
        '$screen-margin-md': 32,
        '$screen-margin-lg': 96
      }
    }
  }
}
</script>

<style lang="scss">
@import '../../../../../lib/design-token/grid-token.scss';

#breakpoints-page {
  display: flex;
  flex-direction: column;

  code {
    font-size: 14px !important;
    color: $color-cool-grey-700 !important;
  }

  .token-section {
    margin-bottom: 48px;

    h3 {
      margin-bottom: 24px;
    }
  }

  .breakpoint-list {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
    gap: 16px;
  }

  .token-item {
    display: flex;
    flex-direction: column;
    padding: 16px;
    // background: $color-cool-grey-50;
    border-radius: 8px;
    gap: 4px;
    border: 1px solid $color-cool-grey-100;
  }

  .token-name {
    color: $color-cool-grey-500;
    font-family: monospace;
    margin-bottom: 8px;
  }

  .token-value {
    color: $color-cool-grey-500;
    font-size: 14px;
  }

  .margin-preview {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 32px;
  }

  .margin-box {
    background: $color-cool-grey-50;
    margin-bottom: 16px;
  }

  .content {
    height: 60px;
    background: $color-cool-grey-200;
  }
}
</style>
